import WebAPI from './api-calls';

const webApi = new WebAPI();

export async function fetchWasteBills() {
  const endpoint = '/api/multiutility/waste-bills';

  const response = await webApi.getFromWebApiWithAccessTokenAsync(endpoint);

  return response.data;
}